module.exports = __webpack_public_path__ + "h5/img/record3.6fd30fda.png";